import { Outlet, useLocation } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import ChatBot from "./ChatBot.js";
import NewChatBot from "./NewChatBot.js";


const WithHeaderLayout = () => {
  const location = useLocation();
  const showFooter = location.pathname === "/home";
  return (
    <div>
      <Header/>
       {/* <ChatBot /> */}
       {/* <NewChatBot /> */}
      <Outlet />
      {showFooter && <Footer />} 
    </div>
  );
};

export default WithHeaderLayout;